import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Sentinel placed after the last row of a list: when it scrolls into view,
// the next page is fetched as a Turbo Stream that appends the rows and
// replaces the sentinel (or removes it on the last page).
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.load()
    }, { rootMargin: "200px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  async load() {
    if (this.loading) return
    this.loading = true
    this.observer.disconnect()

    const response = await fetch(this.urlValue, { headers: { Accept: "text/vnd.turbo-stream.html" } })
    Turbo.renderStreamMessage(await response.text())
  }
}
